/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Execute_Output7Inputs */

const en_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployable agent build`)
};

const ar_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخة وكيل قابلة للنشر`)
};

const bn_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিপ্লয়যোগ্য এজেন্ট বিল্ড`)
};

const de_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereitstellbarer Agent-Build`)
};

const es_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación de agente implementable`)
};

const fr_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construction d'agent déployable`)
};

const pt_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilação de agente implantável`)
};

const zh_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可部署代理构建`)
};

const tr_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dağıtılabilir aracı yapısı`)
};

const ru_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развертываемая сборка агента`)
};

const pl_svc_ai_agent_development_execute_output7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilacja agenta do wdrożenia`)
};

/**
* | output |
* | --- |
* | "Deployable agent build" |
*
* @param {Svc_Ai_Agent_Development_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_execute_output7 = /** @type {((inputs?: Svc_Ai_Agent_Development_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_execute_output7(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_execute_output7(inputs)
	if (locale === "de") return de_svc_ai_agent_development_execute_output7(inputs)
	if (locale === "es") return es_svc_ai_agent_development_execute_output7(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_execute_output7(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_execute_output7(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_execute_output7(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_execute_output7(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_execute_output7(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_execute_output7(inputs)
	return en_svc_ai_agent_development_execute_output7(inputs)
});
export { svc_ai_agent_development_execute_output7 as "svc_ai-agent-development_EXECUTE_output" }